import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { StepIndicator } from 'frontend-utils';

interface HotelBenchmarkInsightCompetitorsCompsetBuilderCompsetBuilderHeaderSignature {
  Args: {
    currentStep: number;
  };
}

export default class HotelBenchmarkInsightCompetitorsCompsetBuilderCompsetBuilderHeader extends Component<HotelBenchmarkInsightCompetitorsCompsetBuilderCompsetBuilderHeaderSignature> {
  @service('benchmark-insight/competitors/compset')
  declare benchmarkInsightCompetitorsCompset: Services['benchmark-insight/competitors/compset'];

  get showUpdateTranslation(): boolean {
    if (!this.benchmarkInsightCompetitorsCompset.compset) {
      return false;
    }

    return Boolean(
      this.benchmarkInsightCompetitorsCompset.compset.compset.length,
    );
  }

  <template>
    <div class="compset-builder__header flex items-center px-500">
      <h3 class="w-1/3">{{t
          (if
            this.showUpdateTranslation
            "settings.competitors.benchmark.compset.builder.header.update"
            "settings.competitors.benchmark.compset.builder.header"
          )
        }}</h3>

      <div class="flex w-1/3 justify-center">
        <div class="compset-builder__header__step-indicator">
          <StepIndicator @currentStep={{@currentStep}} @steps={{3}} />
        </div>
      </div>
    </div>
  </template>
}
